<template>
  <AppWithLoading :fetch="fetchData" v-slot:default="{loader, localLoading}">
    <VCard class="pa-8 mb-5 payment-trial__steps">
      <VList class="d-flex justify-space-between flex-wrap">
        <VListItem
          class="flex-column align-start col-lg-4 col-sm-6"
        >
          <svg
            v-if="account.hasActivePaymentMethod"
            class="payment-trial__steps_success-icon"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              width="40"
              height="40"
              rx="20"
              fill="#1FC57F"
            />
            <path d="M17.1998 26.2833C16.9769 26.2834 16.7562 26.2395 16.5503 26.1542C16.3444 26.0689 16.1573 25.9437 15.9998 25.786L12.2925 22.0807L13.7071 20.6667L17.1998 24.1593L26.2925 15.0667L27.7072 16.4807L18.3998 25.786C18.2423 25.9437 18.0553 26.0689 17.8494 26.1542C17.6434 26.2395 17.4227 26.2834 17.1998 26.2833Z" fill="white" />
          </svg>

          <div class="payment-trial__steps_number" v-else>
            1
          </div>

          <VListItemTitle class="align-self-start mt-7 mb-4">
            {{ $t('addPaymentMethod') }}
          </VListItemTitle>

          <VListItemSubtitle style="max-width: 335px;">
            <div>{{ $t('toChoosePaymentMethod.1') }}</div>
            <RouterLink
              class="button-trial"
              :to="{ name: 'settings',
                     params: { type: settingsTabs.PAYMENT, addType: paymentTabs.INFO } }"
            >
              «{{ $t('toChoosePaymentMethod.2') }}»
            </RouterLink>
          </VListItemSubtitle>
        </VListItem>
        <VListItem
          class="flex-column align-start col-lg-4 col-sm-6"
        >
          <svg
            v-if="planTitle || account.trialEnabled"
            class="payment-trial__steps_success-icon"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              width="40"
              height="40"
              rx="20"
              fill="#1FC57F"
            />
            <path d="M17.1998 26.2833C16.9769 26.2834 16.7562 26.2395 16.5503 26.1542C16.3444 26.0689 16.1573 25.9437 15.9998 25.786L12.2925 22.0807L13.7071 20.6667L17.1998 24.1593L26.2925 15.0667L27.7072 16.4807L18.3998 25.786C18.2423 25.9437 18.0553 26.0689 17.8494 26.1542C17.6434 26.2395 17.4227 26.2834 17.1998 26.2833Z" fill="white" />
          </svg>

          <div class="payment-trial__steps_number" v-else>
            2
          </div>

          <VListItemTitle class="align-self-start mt-7 mb-4">
            <div v-if="planTitle">
              {{ $t('tariffSelected') }} «{{ planTitle }}»
            </div>
            <div v-else-if="account.trialEnabled">
              {{ $t('tariffSelected') }} «{{ account.plan.title }}»
            </div>
            <div v-else>
              {{ $t('chooseTariff') }}
            </div>
          </VListItemTitle>

          <VListItemSubtitle>
            <div v-if="planTitle || account.trialEnabled">
              <div>{{ $t('toChangeTariff') }}</div>
              <RouterLink
                class="button-trial"
                :to="{ name: 'settings',
                       params: { type: settingsTabs.PAYMENT, addType: paymentTabs.PLANS } }"
              >
                «{{ $t('toChooseTariff.2') }}»
              </RouterLink>
            </div>
            <div v-else>
              <div>{{ $t('toChooseTariff.1') }}</div>
              <RouterLink
                class="button-trial"
                :to="{ name: 'settings',
                       params: { type: settingsTabs.PAYMENT, addType: paymentTabs.PLANS } }"
              >
                «{{ $t('toChooseTariff.2') }}»
              </RouterLink>
              <div class="d-inline">
                {{ $t('toChooseTariff.3') }}
              </div>
            </div>
          </VListItemSubtitle>
        </VListItem>
        <VListItem
          class="flex-column align-start col-lg-4 col-sm-6"
        >
          <svg
            v-if="account.trialEnabled"
            class="payment-trial__steps_success-icon"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              width="40"
              height="40"
              rx="20"
              fill="#1FC57F"
            />
            <path d="M17.1998 26.2833C16.9769 26.2834 16.7562 26.2395 16.5503 26.1542C16.3444 26.0689 16.1573 25.9437 15.9998 25.786L12.2925 22.0807L13.7071 20.6667L17.1998 24.1593L26.2925 15.0667L27.7072 16.4807L18.3998 25.786C18.2423 25.9437 18.0553 26.0689 17.8494 26.1542C17.6434 26.2395 17.4227 26.2834 17.1998 26.2833Z" fill="white" />
          </svg>

          <div class="payment-trial__steps_number" v-else>
            3
          </div>

          <VListItemTitle class="align-self-start mt-7">
            <div v-if="account.trialEnabled">
              {{ $t('tariffActivated') }}
            </div>
            <div v-else>
              {{ $t('activateTrialPeriod') }}
            </div>
          </VListItemTitle>

          <VListItemSubtitle style="max-width: 300px;">
            {{ $t('toActivateTrialPeriod.1') }}
            <button @click="loader(() => activateTrial())" :disabled="account.trialEnabled" class="button-trial">
              «{{ $t('toActivateTrialPeriod.2') }}»
            </button>
          </VListItemSubtitle>
        </VListItem>
      </VList>
    </VCard>
    <div class="payment-trial account-card">
      <ProlongSubscription class="mb-5" />
      <template v-if="!localLoading">
        <h2 class="payment-trial__title">
          {{ $t('title') }}
        </h2>
        <div class="payment-trial__warning my-3 d-flex">
          <svg
            class="mr-1"
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_2163_3)">
              <path d="M19.1545 12.775L12.4212 2.14168C11.8545 1.32501 10.9128 0.833344 9.92118 0.833344C8.92952 0.833344 7.98785 1.31668 7.39618 2.16668L0.696182 12.7583C-0.153818 13.975 -0.312151 15.4333 0.279516 16.5583C0.862849 17.6833 2.08785 18.325 3.62118 18.325H16.2212C17.7628 18.325 18.9795 17.6833 19.5629 16.5583C20.1462 15.4333 19.9879 13.9833 19.1545 12.775ZM9.08785 5.83334C9.08785 5.37501 9.46285 5.00001 9.92118 5.00001C10.3795 5.00001 10.7545 5.37501 10.7545 5.83334V10.8333C10.7545 11.2917 10.3795 11.6667 9.92118 11.6667C9.46285 11.6667 9.08785 11.2917 9.08785 10.8333V5.83334ZM9.92118 15.8333C9.22952 15.8333 8.67118 15.275 8.67118 14.5833C8.67118 13.8917 9.22952 13.3333 9.92118 13.3333C10.6128 13.3333 11.1712 13.8917 11.1712 14.5833C11.1712 15.275 10.6128 15.8333 9.92118 15.8333Z" fill="#D2D2D2" />
            </g>
            <defs>
              <clipPath id="clip0_2163_3">
                <rect width="20.0788" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
          {{ $t('paymentTrialWarning') }}
        </div>
        <div v-if="account.driver === paymentDrivers.ALFABANK" class="payment-trial__text mb-3">
          {{ $t('block1Ruble') }}
        </div>
        <div v-if="account.trialEnabled">
          <div class="payment-trial__text">
            {{ trialTextTitle }}
          </div>
          <div class="payment-trial__period">
            {{ $t('currentPeriod') }}: {{ isExpired ? $t('subscriptionExpired') : periodText }}
          </div>
        </div>
        <div v-else-if="paymentMethods.length">
          <div class="payment-trial__subtitle mb-2">
            {{ $t('subtitle') }}
          </div>
          <div>
            <PaymentMethodsListItem
              :method="method"
              :opened-id="openedId"
              :key="index"
              v-for="(method, index) in paymentMethods"
              @fetchData="loader(() => fetchData())"
              @edit="changeOpenedId"
            />
            <PaymentMethodCardAlfabankAdd
              v-if="account.driver === paymentDrivers.ALFABANK"
              :trial-page="true"
              class="mb-10"
            />
            <PaymentMethodDialogAdd
              v-if="account.driver === paymentDrivers.STRIPE"
              :key="date"
              :trial-page="true"
              @created="loader(() => fetchAllAndUpdateKey())"
            />
          </div>
        </div>
        <div v-else class="payment-trial__text payment-trial__no-payment">
          <div class="mb-2">
            {{ $t('noPaymentMethods') }}
          </div>
          <PaymentMethodCardAlfabankAdd
            v-if="account.driver === paymentDrivers.ALFABANK"
            :trial-page="true"
            class="mt-6"
          />
          <PaymentMethodDialogAdd
            v-if="account.driver === paymentDrivers.STRIPE"
            :key="date"
            :trial-page="true"
            @created="loader(() => fetchAllAndUpdateKey())"
          />
        </div>
      </template>
      <div class="d-flex flex-wrap">
        <VBtn
          :disabled="account.trialEnabled"
          color="#1FC57F"
          class="mr-3 button-activate-trial"
          @click="loader(() => activateTrial())"
        >
          {{ $t('activateTrialPeriod') }}
        </VBtn>
        <CancelSubscription>
          <template v-slot:button="{ on, attrs }">
            <VBtn
              v-bind="attrs"
              v-on="on"
              :disabled="!account.trialEnabled"
              color="red"
            >
              {{ $t('disableTrialPeriod') }}
            </VBtn>
          </template>
          <template v-slot:title>
            {{ $t('trialCancelDialogTitle') }}
          </template>
          <template v-slot:paidFor>
            {{ $t('trialCancelDialog') }}
          </template>
          <template v-slot:text>
            {{ $t('trialCancelDialog2') }}
          </template>
          <template v-slot:btnName>
            {{ $t('disableTrialPeriod') }}
          </template>
        </CancelSubscription>
      </div>

      <VDialog v-model="dialogSuccessTrial" :value="dialogSuccessTrial" max-width="500">
        <VCard class="pa-8">
          <DialogHeader :title="dialogSuccessTrialHeader" @close="closeDialogSuccessTrial" />
          <VCardActions class="mt-0 px-0 pb-0">
            <VBtn
              class="ml-0 px-12"
              color="success"
              @click="closeDialogSuccessTrial"
            >
              {{ $t('ok') }}
            </VBtn>
          </VCardActions>
        </VCard>
      </VDialog>

      <VDialog v-model="dialogNeedAddPayment" max-width="500">
        <VCard class="pa-8">
          <DialogHeader :title="$t('dialogNeedAddPaymentHeaderTitle')" @close="closeDialogNeedAddPayment" />
          <VCardActions class="mt-0 px-0 pb-0">
            <VBtn
              class="ml-0"
              width="49%"
              color="success"
              @click="addPaymentMethod"
            >
              {{ $t('addPaymentMethod') }}
            </VBtn>
            <VBtn
              class="ml-2"
              width="49%"
              color="success"
              @click="closeDialogNeedAddPayment"
            >
              {{ $t('cancel') }}
            </VBtn>
          </VCardActions>
        </VCard>
      </VDialog>
    </div>
  </AppWithLoading>
</template>

<script>
import usePaymentMethods from '@/compositions/accounting/usePaymentMethods';
import PaymentMethodsListItem from '@/components/Payment/Methods/PaymentMethodsListItem';
import AppWithLoading from '@/components/AppWithLoading';
import useAccount from '@/compositions/accounting/useAccount';
import ProlongSubscription from '@/components/Payment/Subscription/ProlongSubscription';
import { ref, computed, toRefs } from '@vue/composition-api';
import Country from '@/orm/models/Country/Country';
import useSubscription from '@/compositions/accounting/useSubscription';
import CancelSubscription from '@/components/Payment/Subscription/CancelSubscription';
import useValidation from '@/compositions/useValidation';
import { paymentTabs, settingsTabs, paymentDrivers } from '@/enums';
import DialogHeader from '@/components/DialogHeader.vue';
import { useI18n } from 'vue-i18n-composable';
import PaymentMethodCardAlfabankAdd from '@/components/Payment/Methods/PaymentMethodCardAlfabankAdd';
import PaymentMethodDialogAdd from '@/components/Payment/Methods/PaymentMethodDialogAdd';
import useAlfabank from '@/compositions/accounting/useAlfabank';
import usePlan from '@/compositions/accounting/usePlan';

export default {
  name: 'PaymenTrial',
  components: {
    ProlongSubscription,
    AppWithLoading,
    CancelSubscription,
    PaymentMethodsListItem,
    PaymentMethodCardAlfabankAdd,
    PaymentMethodDialogAdd,
    DialogHeader,
  },
  props: {
    planId: {
      type: Number,
      default: null,
    },
    planTitle: {
      type: String,
      default: null,
    },
    periodId: {
      type: Number,
      default: null,
    },
  },
  setup(props, { root: { $router } }) {
    const { planTitle, planId, periodId } = toRefs(props);
    const openedId = ref(null);
    const date = ref(Date.now());
    const {
      account, startTrial, periodText, fetch,
    } = useAccount();
    const { fetchAll: fetchPlans } = usePlan();
    const { createPaymentMethod } = useAlfabank();
    const { isExpired } = useSubscription();
    const dialogSuccessTrial = ref(false);
    const dialogNeedAddPayment = ref(false);
    const { t } = useI18n();

    function changeOpenedId(id) {
      openedId.value = id;
    }
    const { fetchAll, paymentMethods } = usePaymentMethods();
    const { hasActivePaymentMethod, fetchIfNull } = useAccount();
    const { withValidationHandling } = useValidation();

    const trialTextTitle = computed(() => `${t('trialText')} «${account.value.plan.title}»`);
    const dialogSuccessTrialHeader = computed(() => `${t('dialogSuccessTrialHeaderTitle')} «${planTitle.value}»`);

    async function loadCountries() {
      if (Country.all().length > 1) {
        return;
      }
      await withValidationHandling(async () => {
        await Country.api()
          .fetch();
      });
    }

    function fetchData() {
      return Promise.all([fetchIfNull(), fetchAll(), loadCountries()]);
    }

    async function fetchAllAndUpdateKey() {
      date.value = Date.now();
      await fetchData();
    }

    function closeDialogSuccessTrial() {
      dialogSuccessTrial.value = false;
    }

    function closeDialogNeedAddPayment() {
      dialogNeedAddPayment.value = false;
    }

    function openDialogSuccessTrial() {
      dialogSuccessTrial.value = true;
    }

    async function activateTrial() {
      if (!planId.value) {
        await $router.push({
          name: 'settings',
          params: {
            type: settingsTabs.PAYMENT,
            addType: paymentTabs.PLANS,
          },
        });
        return;
      }

      if (!hasActivePaymentMethod.value) {
        dialogNeedAddPayment.value = true;
        return;
      }

      await startTrial({
        planId: planId.value,
        periodId: periodId.value,
      });
      await fetchPlans();
      await fetch();
      openDialogSuccessTrial();
    }

    async function addPaymentMethod() {
      const result = await createPaymentMethod();
      if (result && result.redirect) {
        document.location.href = result.redirect;
      }
    }

    return {
      paymentMethods,
      fetchData,
      hasActivePaymentMethod,
      openedId,
      changeOpenedId,
      date,
      fetchAllAndUpdateKey,
      settingsTabs,
      paymentTabs,
      paymentDrivers,
      account,
      activateTrial,
      trialTextTitle,
      dialogSuccessTrial,
      closeDialogSuccessTrial,
      dialogSuccessTrialHeader,
      openDialogSuccessTrial,
      periodText,
      isExpired,
      dialogNeedAddPayment,
      addPaymentMethod,
      closeDialogNeedAddPayment,
    };
  },
};
</script>

<style lang="scss" scoped>
.payment-trial {
  min-height: calc(100vh - 28rem);
  padding: 2.1875rem 2.5rem 2.5rem 2.5rem;
  &__title {
    font-size: 1.5rem;
    line-height: 1.2;
    font-weight: 400;
    color: #212121;
  }
  &__text {
    font-size: 1.0625rem;
    font-weight: 400;
    color: #212121;
  }
  &__period {
    margin: 12px 0 12px 0;
    font-size: 0.875rem;
    line-height: 1.57;
    color: #757575;
  }
  &__no-payment {
    margin-bottom: 1rem;
  }
  &__warning {
    svg {
      @media screen and (max-width: 1263px) {
        margin-top: 4px;
      }
    }
  }
  &__steps {
    @media screen and (max-width: 428px) {
      padding: 20px !important;
    }
    .v-list-item::v-deep {
      min-height: auto;
    }

    .v-list-item__title::v-deep {
      font-weight: 400;
      font-size: 20px;
      line-height: 100%;
      color: #212121;
      white-space: normal;
      @media screen and (max-width: 600px) {
        margin: 7px 0 8px 40px !important;
      }
      @media screen and (max-width: 428px) {
        font-size: 17px;
      }
    }
    .v-list-item__subtitle::v-deep {
      white-space: normal;
      font-weight: 300;
      font-size: 16px;
      line-height: 120%;
      color: #666666;
      height: 100%;
      @media screen and (max-width: 600px) {
        margin-left: 40px;
      }
    }
    &_success-icon {
      height: 100%;
      min-height: 40px;
      @media screen and (max-width: 600px) {
        position: absolute;
        left: 0;
        height: auto;
      }
    }
    &_number {
      border-radius: 50%;
      width: 40px;
      height: 40px;
      padding: 10px;

      background: #fff;
      border: 1px solid #EDEDED;
      text-align: center;

      font-weight: 400;
      font-size: 19px;
      line-height: 100%;
      color: #666666;
      @media screen and (max-width: 600px) {
        position: absolute;
        left: 0;
      }
    }
  }
  @media #{map-get($display-breakpoints, 'md-and-down')} {
    .payment-trial {
      padding: 1.875rem 1rem 0.125rem;
      &__title {
        font-size: 1.25rem;
        margin-bottom: 1rem;
      }
      &__text {
        font-size: 0.9375rem;
        margin-bottom: 1.5rem;
      }
    }
  }
  @media #{map-get($display-breakpoints, 'xs-only')} {
    .payment-trial {
      padding: 1.25rem 0.625rem 0.125rem;
      &__title {
        font-size: 1rem;
        line-height: 1.2;
        font-weight: 500;
        padding: 0 0.625rem;
        margin-bottom: 0.75rem;
      }
      &__text {
        font-size: 0.8125rem;
        padding: 0 0.625rem;
        margin-bottom: 1rem;
      }
    }
  }
}

.account-card {
  background: #FFFFFF;
  box-shadow: 0px 2px 0.5rem rgba(0, 0, 0, 0.16);
  border-radius: 0.625rem;
}

.button-trial {
  color: #0A82D9 !important;
  text-decoration: underline;
  text-underline-position: under;
  cursor: pointer;
}

.button-activate-trial {
  @media screen and (max-width: 620px) {
    margin-bottom: 12px;
  }
}
.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none;
}
.v-card::v-deep {
  background-color: #F5F5F5;
  border-radius: 10px;
}
.v-list::v-deep {
  background-color: #F5F5F5;
}
.v-list-item__subtitle {
  flex: auto;
  overflow: inherit;
}
</style>

<i18n lang="yml" locale="ru">
  title: Пробный период
  subtitle: 'Выберите способ оплаты:'
  addPaymentMethod: Добавить способ оплаты
  noPaymentMethods: У вас нет сохранённых способов оплаты
  activateTrialPeriod: Подключить пробный период
  disableTrialPeriod: Отключить пробный период
  paymentTrialWarning: Оплата тарифа происходит спустя 30 дней с момента активации пробного периода
  dialogSuccessTrialHeaderTitle: Вы активировали пробный период тарифа
  ok: Ок
  cancel: Отмена
  dialogApplyingTrialHeaderTitle: Вы уверены, что хотите подключить пробный период тарифа
  dialogNeedAddPaymentHeaderTitle: Необходимо добавить способ оплаты
  trialText: У вас подключен пробный период тарифа
  currentPeriod: Текущий период
  subscriptionExpired: Подписка закончилась
  changeTariff: Сменить тариф
  trialCancelDialogTitle: Отмена пробного периода
  trialCancelDialog: Ваш пробный период активирован
  trialCancelDialog2: 'После окончания пробного периода Вы перейдете на бесплатный тариф «Промо».
  Если вы отмените пробный период сегодня, то сможете пользоваться сервисом до указанной даты. Счёт за следующий период выставлен не будет.'
  block1Ruble: Для добавления новой карты, мы заблокируем и разблокируем 1 рубль с вашей карты. Вы будете перенаправлены на сайт платежной системы.
  chooseTariff: Выберите тариф
  tariffsAndQuotas: Тарифы и Квоты
  toChoosePaymentMethod: {
    1: 'Для активации пробного периода, добавьте',
    2: Способ оплаты
  }
  toChooseTariff: {
    1: Для выбора тарифа перейдите в,
    2: Тарифы и Квоты,
    3: и нажмите «Попробовать»
  }
  toActivateTrialPeriod: {
    1: Для активации нажмите,
    2: Подключить пробный период
  }
  toChangeTariff: Для смены тарифа перейдите в
  tariffSelected: Выбран тариф
  tariffActivated: Пробный период подключен
</i18n>
<i18n lang="yml" locale="en">
  title: Trial period
  subtitle: 'Select a Payment Method:'
  addPaymentMethod: Add a payment method
  noPaymentMethods: Please add a payment method
  activateTrialPeriod: Activate your 30-day trial period
  disableTrialPeriod: Disable the trial period
  paymentTrialWarning: You will be charged at your new tariff, 30 days after the trial period activation
  dialogSuccessTrialHeaderTitle: You have activated a 30-day trial period with the tariff
  ok: Ok
  cancel: Cancel
  dialogApplyingTrialHeaderTitle: Are you sure you want to activate the trial period of the tariff
  dialogNeedAddPaymentHeaderTitle: You need to add a payment method
  trialText: You have activated a 30-day trial period with the tariff
  currentPeriod: Current period
  subscriptionExpired: Subscription has expired
  changeTariff: Change the tariff
  trialCancelDialogTitle: Cancellation of the trial period
  trialCancelDialog: Your trial period is activate
  trialCancelDialog2: 'At the end of the trial period, you will automatically be switched to the free "Promo" tariff.
  If you cancel the trial period today, you will be able to use the service until the specified expiration date. No invoice will be issued for the next period.'
  block1Ruble: To add a new card, we will block and unlock 1 ruble from your card. You will be redirected to the payment system's website.
  chooseTariff: Choose a tariff
  tariffsAndQuotas: Tariffs and Quotas
  toChoosePaymentMethod: {
    1: 'To activate the trial period, add a',
    2: Payment method
  }
  toChooseTariff: {
    1: 'To select a tariff, go to',
    2: Tariffs and Quotas,
    3: and click «Try»
  }
  toActivateTrialPeriod: {
    1: 'To activate, click',
    2: Enable the trial period
  }
  toChangeTariff: To change the tariff, go to
  tariffSelected: You have selected the tariff
  tariffActivated: The trial period is activated
</i18n>
